import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import RadioSelect from "../ui/checkboxs/RadioSelect";
import ValueRange from "../ui/inputs/ValueRange";
import { Search } from "./SearchTypes";
import ApiProxy from "../../ts/ApiProxy";
import CheckboxSmall from "../ui/checkboxs/CheckboxSmall";
import { Emitter } from "strict-event-emitter";
import SearchPopup from "../popups/SearchPopup";
import SearchManager from "./SearchManager";
import PatternSamples from "../../ts/PatternSamples";
import Tools from "../../ts/Tools";

export default class SearchFilter extends ComponentBase
{
  emitter: Emitter<{ change: [type: Search.SearchInputTypes] }>;

  input: Search.SearchInput = {};

  _timeRadio: RadioSelect;
  _siteRadio: RadioSelect;
  _priceRange: ValueRange;

  _priceSetting: Search.Price;

  constructor(elem: ComponentElem)
  {
    super(elem);

    this.emitter = new Emitter();

    let pageData: Search.PageData = ApiProxy.getPageData();

    this._priceSetting = pageData.filter_setting.price;

    SetupExtraSerachFilters(this, this._priceSetting, pageData.filter_setting.site_option);
  }

  syncInput(input: Search.SearchInput)
  {
    this.input = Object.assign({}, input);
    delete this.input.page_index;
    SearchSyncExtraInput.call(this, input);
  }

  testTimeInput(start: string, end: string, input: Search.SearchInput)
  {
    if (start && end) {
      if (PatternSamples["time"].test(start) && PatternSamples["time"].test(end)) {
        input.start_time = start;
        input.end_time = end;
      }
    }
  }

  testPriceInput(min: string, max: string, input: Search.SearchInput)
  {
    let minNumber = Number(min),
      maxNumber = Number(max);

    if (Number.isInteger(minNumber) && Number.isInteger(maxNumber) &&
      minNumber >= this._priceSetting.min && maxNumber <= this._priceSetting.max && minNumber <= maxNumber
    ) {
      input.min_price = minNumber;
      input.max_price = maxNumber;
    }
  }

  testSiteInput(siteString: string, input: Search.SearchInput)
  {
    if(!siteString) return;    

    let dic = Tools.listToDic((ApiProxy.getPageData() as Search.PageData).filter_setting.site_option),
      list = siteString.split(","),
      array: string[] = [];

    if(list.length === 0) return;      

    list.forEach((site: string)=>
    {
      if(dic[site]) array.push(site);
    });

    input.site_list = array;
  }
}

export function SetupExtraSerachFilters(component: SearchFilter | SearchPopup, priceSetting: Search.Price, siteOptionList: string[])
{
  component._timeRadio = setupTime.call(component);
  component._priceRange = setupPrice.call(component, priceSetting);
  component._siteRadio = setupSite.call(component, siteOptionList);
}

/**
 * Side props
 */
export function SearchSyncExtraInput(input: Search.SearchInput)
{
  // console.log(input);  

  let timeValue = (this.input.start_time && this.input.end_time) ? `${this.input.start_time} ~ ${this.input.end_time}` : "all"

  this._timeRadio.setValue(timeValue);

  if (input.min_price === undefined && input.max_price === undefined) {
    this._priceRange.setValue(undefined, undefined, false);
  }
  else {
    let minPercent = (input.min_price - this._priceSetting.min) / (this._priceSetting.max - this._priceSetting.min),
      maxPercent = (input.max_price - this._priceSetting.min) / (this._priceSetting.max - this._priceSetting.min);
    this._priceRange.setValue(minPercent, maxPercent, false);
  }

  this._siteRadio.setValue(input.site_list ? input.site_list : []);
}

function setupTime()
{
  this.input.start_time = undefined;
  this.input.end_time = undefined;

  let timeRadio = <RadioSelect>this.seekComponentByField("time");
  timeRadio.emitter.on("change", () =>
  {
    let oldStart = this.input.start_time,
      oldEnd = this.input.end_time;

    // console.log(timeRadio.getValue());

    let value: string = timeRadio.getValue() as string;

    if (value === "all") {
      this.input.start_time = undefined;
      this.input.end_time = undefined;
    }
    else {
      let array = (<string>timeRadio.getValue()).split(" ~ ");
      this.input.start_time = array[0];
      this.input.end_time = array[1];
    }

    if (this.input.start_time !== oldStart || this.input.end_time !== oldEnd) this.emitter.emit("change", "time");
  });

  return timeRadio;
}

function setupPrice(priceSetting: Search.Price)
{


  let priceRange = <ValueRange>this.seekComponentByName("value-range");
  priceRange.setRange(priceSetting.min, priceSetting.max);

  this.input.min_price = priceSetting.min;
  this.input.max_price = priceSetting.max;

  priceRange.emitter.on("update", (result) =>
  {
    let oldMin = this.input.min_price,
      oldMax = this.input.max_price;
    this.input.min_price = result.min;
    this.input.max_price = result.max;

    if (this.input.min_price !== oldMin || this.input.max_price !== oldMax) this.emitter.emit("change", "price");
  });

  return priceRange;
}

function setupSite(siteOptionList: string[])
{
  this.input.site_list = [];

  let siteRadio = <RadioSelect>this.seekComponentByField("site");

  setupSiteOptions(siteRadio, siteOptionList);

  siteRadio.emitter.on("change", () =>
  {
    let oldLength = this.input.site_list ? this.input.site_list.length : -1;
    this.input.site_list = siteRadio.getValue();

    if (oldLength !== this.input.site_list.length) this.emitter.emit("change", "site");
  });

  return siteRadio;
}


function setupSiteOptions(siteRadio: RadioSelect, siteOptionList: string[])
{

  let sampleHtml = siteRadio.$root.find(`[component="checkbox-small"]`)[0].outerHTML;
  siteRadio.$root.empty();

  siteOptionList.forEach((siteId: string) =>
  {
    let $elem = $(sampleHtml);
    $elem.attr("data-value", siteId);
    $elem.find(".text").html(siteId);
    siteRadio.$root.append($elem);

    new CheckboxSmall($elem[0]);
  });

  siteRadio.resetOptions();
}